import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Serve the worker from our own /public folder (copied from pdfjs-dist) so it works offline / in prod.
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export async function loadPdf(data) {
  // data: ArrayBuffer
  return pdfjsLib.getDocument({ data }).promise;
}

export async function renderPageToCanvas(pdf, pageNum, canvas, targetWidth) {
  const page = await pdf.getPage(pageNum);
  const base = page.getViewport({ scale: 1 });
  const scale = targetWidth / base.width;
  const viewport = page.getViewport({ scale });
  canvas.width = viewport.width;
  canvas.height = viewport.height;
  const ctx = canvas.getContext("2d");
  await page.render({ canvasContext: ctx, viewport }).promise;
  return { w: viewport.width, h: viewport.height };
}
